import { localUi } from "../i18n/uiFallback";

type Mode = "letter" | "chat";

export function ModeToggle({
  mode,
  onChange,
  locale,
}: {
  mode: Mode;
  onChange: (m: Mode) => void;
  locale: string;
}) {
  return (
    <div className="mode-toggle" role="radiogroup" aria-label="Mode">
      <button
        role="radio"
        aria-checked={mode === "letter"}
        className={`mode-toggle__btn ${mode === "letter" ? "is-on" : ""}`}
        onClick={() => onChange("letter")}
      >
        <span className="mode-toggle__icon">📖</span>
        <span className="mode-toggle__label">{localUi(locale, "mode_letter")}</span>
      </button>
      <button
        role="radio"
        aria-checked={mode === "chat"}
        className={`mode-toggle__btn ${mode === "chat" ? "is-on" : ""}`}
        onClick={() => onChange("chat")}
      >
        <span className="mode-toggle__icon">💬</span>
        <span className="mode-toggle__label">{localUi(locale, "mode_chat")}</span>
      </button>
    </div>
  );
}
